<template>
  <v-row justify="center">
    <v-dialog v-model="dialogMoodle" persistent max-width="auto">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <v-row align="center">
            <v-col cols="12" v-if="!categoria">
              <p class="font-weight-bold">Categoria no asignada al programa</p>
            </v-col>
            <v-col cols="12" v-else>
              <p class="font-weight-bold text-center h4">{{ categoria.name }}</p>
              <v-data-table :headers="headers" :items="cursos" item-key="id" :search="search" :items-per-page="-1">
                <template v-slot:top>
                  <v-text-field
                    dense
                    outlined
                    v-model="search"
                    label="Buscar Curso en  la lista"
                    class="mx-4"></v-text-field>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip bottom>
                    <template #activator="{ on, attrs }">
                      <v-icon class="ma-2" v-bind="attrs" v-on="on" color="light-blue" @click="assignCourse(item)"
                        >mdi-clipboard-check</v-icon
                      >
                    </template>
                    Asignar Este Curso al Modulo
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" outlined rounded @click="closeDialogMoodle">
            Cerrar <v-icon> mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import xaxios from '@/xaxios';
import moment from 'moment';
import gql from 'graphql-tag';
import { parseDateWithMiddleDash } from '@/components/Utils.js';
import { mapState } from 'vuex';
export default {
  props: ['modulo', 'course_name', 'course_id'],
  data() {
    return {
      menu_name: process.env.VUE_APP_NAME_MENU,
      // api_rest_moodle: process.env.UE_APP_API_REST_MOODLE,
      categoria: null,
      fullname: this.course_name,
      programa: null,
      dialogMoodle: false,
      categorias: [],
      cursos: [],
      search: '',
      headers: [
        { text: 'id', value: 'id', width: 50 },
        { text: 'Nombre', value: 'fullname' },
        { text: 'Fecha Inicio', value: 'startdate', width: 120, sortable: false },
        { text: 'Fecha Fin', value: 'enddate', width: 120, sortable: false },
        { text: 'Opciones', value: 'actions', sortable: false },
      ],

      datamsg: '',
      plataforma: {},
      plataformas: [],
      msgerr: '',
    };
  },
  watch: {
    UNIDAD_NEGOCIO_ID() {
      this.plataformas = [];
      this.getDatosPlataformas();
    },
  },
  computed: {
    ...mapState({
      // programa: (state) => state.programa.value,
      UNIDAD_NEGOCIO_ID: (state) => state.UNIDAD_NEGOCIO_ID,
    }),
  },
  methods: {
    showThisView(modulo, programa) {
      this.getprogramax(programa);
      this.dialogMoodle = true;
      this.programa = programa;
      if (this.programa.course_category_id != null) {
        this.loadCourses(this.programa.course_category_id);
      }
    },
    assignCourse(course) {
      this.$root.$confirm
        .open('Asignar Curso Mooodle a Modulo', 'Estas seguro de asignar?', { color: 'orange' })
        .then((confirm) => {
          if (this.modulo && this.programa && confirm) {
            const sql = gql`mutation{asignarCourseProgramaModulo(input:{idmodulo: ${this.modulo.id}, idprograma: ${this.programa.id},course_id: ${course.id}}){ ok,  errors{message}}}`;
            this.$apollo
              .mutate({ mutation: sql })
              .then(({ data: { asignarCourseProgramaModulo } }) => {
                if (asignarCourseProgramaModulo.ok) {
                  this.$root.$notify.show('ID curso asignado exitosamente');
                  this.course_id = course.id;
                  this.$emit('update:course_id', this.course_id);
                  this.fullname = course.fullname;
                  this.$emit('update:course_name', this.fullname);
                  this.dialogMoodle = false;
                } else {
                  asignarCourseProgramaModulo.errors.forEach((error) => {
                    this.$root.$notify.show(error.message);
                  });
                }
              })
              .catch((err) => window.console.error(err));
          }
        });
    },
    loadCourses(id) {
      if (id && !this.categoria) {
        this.msgerr = '';
        /*if( !this.plataforma.id ){
          this.getprogramax();
        }*/
        // window.console.log(`${this.plataforma.direccion}/esam/category/id/${id}/course`)
        xaxios
          .get(
            `${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(/\/$/, '')}/plataformas/${
              this.plataforma.id
            }/category/id/${id}/course`,
          )
          .then(({ data }) => {
            this.categoria = data;
            data.courses.map((curso) => {
              curso.startdate = moment.utc(parseInt(curso.startdate)).format('L');
              curso.enddate = parseDateWithMiddleDash(new Date(curso.enddate * 1000));
              return curso;
            });
            this.cursos = data.courses;
          })
          .catch((err) => window.console.error('error', err));
      }
    },
    closeDialogMoodle() {
      this.dialogMoodle = false;
    },

    getDatosPlataformas(programa) {
      this.$apollo
        .query({
          query: gql`query { getPlataformas(estado: true,unidad_negocio_id: ${this.UNIDAD_NEGOCIO_ID}) { id nombre direccion unidad_negocio_id estado }}`,
        })
        .then(({ data: { getPlataformas } }) => {
          this.plataformas = getPlataformas;
          if (programa) {
            let plataforma_id = programa.plataforma_id;
            this.plataforma = this.plataformas.find((x) => x.id == plataforma_id);
            this.datamsg = `<b>Plataforma</b>: ${this.plataforma.nombre}`;
          }
        })
        .catch((err) => this.$root.$notify.show(`ERROR: getPlataformas(AssignCourseId) ${err}`));
    },
    getprogramax(programa) {
      if (programa) {
        let plataforma_id = programa.plataforma_id;
        this.plataforma = this.plataformas.find((x) => x.id == plataforma_id);
        this.datamsg = `<b>Plataforma</b>: ${this.plataforma.nombre}`;
      }
    },
  },
  mounted() {
    this.getDatosPlataformas();
  },
};
</script>
